'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'narwhal';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'f6fe';
var svgPathData = 'M630 34.5L580.6 204.6c-.5-.5-1.1-1-1.6-1.4 37.3 32.3 61 79.8 61 132.8 0 97.2-78.8 176-176 176l-240 0c-88.4 0-160-71.6-160-160l0-98.9-57.2-40-6.8-4.8 0-8.3 0-88 0-30.7c16 11.2 37.8 26.4 96 67.2l70.8-49.6c5-3.5 13.4-9.4 25.2-17.6 0 19.3 0 46.4 0 118.7l0 8.3-6.8 4.8-57.2 40 0 114.9 16-13 178.9-145.4c39.5-32.1 89.3-49.6 140.2-49.6 9.4 0 18.7 .7 27.7 2.2L615.7 26.5 640 0 630 34.5zM509 166c21.2 5.7 40.8 15.2 58.1 27.7L605.6 61 509 166zM96 168l-9.2-6.4-70.8-49.6 0 88 57.2 40 6.8 4.8 0 107.2c0 79.5 64.5 144 144 144l240 0c88.4 0 160-71.6 160-160 0-88.3-72.4-160-160.9-160-47.3 0-93.4 16.3-130.1 46l-194.9 158.4-26.1 21.2 0-156.8 6.8-4.8 57.2-40 0-88-70.8 49.6-9.2 6.4zM480 304a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faNarwhal = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;